module.exports = __webpack_public_path__ + "media/images/logos/steam-light-cc2d89bafa574e36a24016d4638f5127.svg";